import { PureAbility, type AbilityClass, type RawRuleOf } from '@casl/ability'

export type AppAbility = PureAbility<[string, string]>
const AppAbilityCtor = PureAbility as AbilityClass<AppAbility>

export const ability = new AppAbilityCtor([])

export function buildRules(permissions: string[]): RawRuleOf<AppAbility>[] {
  const rules: RawRuleOf<AppAbility>[] = []
  for (const p of permissions) {
    const i = p.lastIndexOf('.')
    if (i < 0) continue
    rules.push({ action: p.slice(i + 1), subject: p.slice(0, i) })
  }
  return rules
}

export function updateAbility(permissions: string[]) {
  ability.update(buildRules(permissions))
}
